<template>
  <a target="_blank" :href="collection.premint_link" class="buy-now__shared">Purchase Set</a>
</template>

<script>
export default {
    props: ['collection']
}
</script>
